var map = {
	".": "kq5u",
	"./": "kq5u",
	"./01_limit": "WMCK",
	"./01_limit.json": "WMCK",
	"./02_connect": "Jf00",
	"./02_connect.json": "Jf00",
	"./03_data_compress": "eQk0",
	"./03_data_compress.json": "eQk0",
	"./04_heart_beat": "nCmZ",
	"./04_heart_beat.json": "nCmZ",
	"./05_subscribe": "D11h",
	"./05_subscribe.json": "D11h",
	"./06_cancel_subscribe": "8PHc",
	"./06_cancel_subscribe.json": "8PHc",
	"./index": "kq5u",
	"./index.js": "kq5u"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hpFp";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/websocket/introduce ^.*$
// module id = hpFp
// module chunks = 3